import { jsxs, jsx } from 'react/jsx-runtime';
import styles from './HeroCard.module.css.js';

function HeroCard({ image, children, className = '', ...rest }) {
    return (jsxs("div", Object.assign({ className: `${styles.wrap} ${className}` }, rest, { children: [jsx("div", Object.assign({ className: styles.image }, { children: image }), void 0), jsx("div", Object.assign({ className: styles.content }, { children: children }), void 0)] }), void 0));
}

export { HeroCard };
//# sourceMappingURL=HeroCard.js.map
